import { Directive } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';
import { FieldType } from '@ngx-formly/core';

import { ISPFieldConfig } from './field-config.interface';
import { ISPFieldType } from './field-type.enum';
import { ISPFormOptions } from './form-options.interface';
import { ISPFormState } from './form-state.interface';
import { ISPTemplateOptions } from './template-options.interface';

/**
 * Base Formly field type class for Dragon theme
 */
@UntilDestroy()
@Directive()
export class ISPFieldTypeBase<
  T extends ISPFieldType = ISPFieldType,
> extends FieldType {
  field: ISPFieldConfig<T>;

  readonly key: string;

  readonly to: ISPTemplateOptions<T>;

  readonly options: ISPFormOptions;

  readonly formState: ISPFormState;
}
